import { useCallback, useMemo } from 'react';

import { useIntegrationsPage } from 'pages/Settings/integrations/hooks/useIntegrationsPage';

export const useIntegrationsForm = ({ network, linkedinSyncBasePath, linkedinSyncReturnTo, onGoogleSyncComplete }) => {
  const { googleSync, googleLogin, linkedinSync } = useIntegrationsPage({ network, onGoogleSyncComplete });

  // Check if LinkedIn is connected
  const isLinkedinConnected = !!linkedinSync?.syncStatus && linkedinSync.syncStatus !== 'not_connected';

  // Check if Google is connected
  const isGoogleConnected = !!googleSync?.syncStatus && googleSync.syncStatus !== 'not_connected';

  // Show Continue button when both integrations are done
  const allIntegrationsDone = useMemo(
    () => isLinkedinConnected && isGoogleConnected,
    [isLinkedinConnected, isGoogleConnected],
  );

  // Check if at least one integration has been done
  const anyIntegrationDone = useMemo(
    () => isLinkedinConnected || isGoogleConnected,
    [isLinkedinConnected, isGoogleConnected],
  );

  // Generate LinkedIn sync link with configurable base path and return URL
  const getLinkedinSyncLink = useCallback(
    (status = 'sync') => {
      const baseUrl = `${linkedinSyncBasePath}/${status}`;
      return linkedinSyncReturnTo ? `${baseUrl}?returnTo=${linkedinSyncReturnTo}` : baseUrl;
    },
    [linkedinSyncBasePath, linkedinSyncReturnTo],
  );

  return {
    googleSync,
    googleLogin,
    linkedinSync,
    allIntegrationsDone,
    anyIntegrationDone,
    getLinkedinSyncLink,
  };
};
